import CampaignGoals from './CampaignGoals';

export default CampaignGoals;
